export const SCHEMA_PUMP = [
  {
    table_id: 'ced_output_pump',
    col_id: 'casing_id',
    col_name: 'Casing ID',
    col_desc: 'Casing ID',
    col_unit: '-',
    ui_editable: false,
    ui_show: false,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'casing_type',
    col_name: 'Casing Type',
    col_desc: 'Casing Type',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'cement_id',
    col_name: 'Cement ID #',
    col_desc: 'Cement ID #',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'stage',
    col_name: 'Stage',
    col_desc: 'Stage',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_pump',
    col_id: 't',
    col_name: 'Time',
    col_desc: 'Time',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'q',
    col_name: 'Flow rate',
    col_desc: 'Flow rate',
    col_unit: 'ppm',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'fluid_type',
    col_name: 'Current Pumping Fluid',
    col_desc: 'Current Pumping Fluid',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'dVol',
    col_name: 'Pumped Volume',
    col_desc: 'Pumped Volume',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'cum_vol',
    col_name: 'Cum Volume',
    col_desc: 'Cumulative Pumped Volume',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_mud_tub',
    col_name: 'Mud Length (Tubing)',
    col_desc: 'Length of Mud Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_mud_ann',
    col_name: 'Mud Length (Annulus)',
    col_desc: 'Length of Mud Fluid inside Annulus',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_spacer_tub',
    col_name: 'Spacer Length (Tubing)',
    col_desc: 'Length of Spacer Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_spacer_ann',
    col_name: 'Spacer Length (Annulus)',
    col_desc: 'Length of Spacer Fluid inside Annulus',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_lead_tub',
    col_name: 'Lead Length (Tubing)',
    col_desc: 'Length of Lead Cement inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_lead_ann',
    col_name: 'Lead Length (Annulus)',
    col_desc: 'Length of Lead Cement inside Annulus',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_tail_tub',
    col_name: 'Tail Length (Tubing)',
    col_desc: 'Length of Tail Cement inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_tail_ann',
    col_name: 'Tail Length (Annulus)',
    col_desc: 'Length of Tail Cement inside Annulus',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'l_displacement_tub',
    col_name: 'Displacement Length (Tubing)',
    col_desc: 'Length of Displacement Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'p_pump',
    col_name: 'Pump Pressure',
    col_desc: 'Required Surface Pump Pressure',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'ced_output_pump',
    col_id: 'hp',
    col_name: 'Pump Power',
    col_desc: 'Require Surface Pump Power',
    col_unit: 'Hp',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  }
];

export default SCHEMA_PUMP;
